"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Date helper functions are the only methods
// allowed to import directly from any 3rd party date utility library.
// eslint-disable-next-line no-restricted-imports
var date_fns_1 = require("date-fns");
var en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
var da_1 = __importDefault(require("date-fns/locale/da"));
var languageToLocaleMap = {
    en: en_GB_1.default,
    da: da_1.default,
};
var DATE_FORMAT = 'dd/MM/yyyy';
var DATE_TIME_FORMAT = DATE_FORMAT + " HH:mm";
// Disabled since the parameter list has to match function in library
// eslint-disable-next-line max-params
function format(date, format, options) {
    try {
        return date_fns_1.format(date, format, options);
    }
    catch (err) {
        return 'Error parsing date';
    }
}
exports.parseDateTimeString = function (dateTime) { return date_fns_1.parseJSON(dateTime); };
exports.formatDateTime = function (dateTime, _a) {
    var _b = _a === void 0 ? { language: 'en' } : _a, language = _b.language, alternativeFormat = _b.alternativeFormat;
    return format(exports.parseDateTimeString(dateTime), alternativeFormat || DATE_TIME_FORMAT, {
        locale: languageToLocaleMap[language],
    });
};
exports.formatDate = function (date, _a) {
    var _b = _a === void 0 ? { language: 'en' } : _a, language = _b.language, alternativeFormat = _b.alternativeFormat;
    return format(date, alternativeFormat || DATE_FORMAT, {
        locale: languageToLocaleMap[language],
    });
};
exports.formatUnixTimestamp = function (unixTimestamp) {
    return format(date_fns_1.fromUnixTime(unixTimestamp), DATE_FORMAT);
};
exports.formatDuration = function (seconds) {
    if (seconds < 0) {
        return '-';
    }
    var inMinutes = Math.floor((seconds || 0) / 60);
    var hours = Math.floor(inMinutes / 60);
    var minutes = inMinutes % 60;
    var formattedHours = hours.toString();
    if (hours < 10) {
        formattedHours = "0" + formattedHours;
    }
    var formattedMinutes = minutes.toString();
    if (minutes < 10) {
        formattedMinutes = "0" + formattedMinutes;
    }
    return formattedHours + ":" + formattedMinutes;
};
